import { Grid, Space, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CenteredLoading } from 'components/CenteredLoading';
import { MfaCard } from 'components/MfaCard/MfaCard';
import { useUserData } from 'hooks/api/useUser';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { PortalButton } from 'components/Button/PortalButton';
import { BsFillLockFill } from 'react-icons/bs';
import { useDrawerContext } from 'context/hooks';
import { GeneralForm } from './GeneralForm';
import { PasswordForm } from './PasswordForm';

export const Profile = () => {
  const { t } = useTranslation();
  const { data: userData, isLoading: isLoadingUser } = useUserData();
  const { openDrawer } = useDrawerContext();

  if (isLoadingUser) return <CenteredLoading />;

  return (
    <Grid>
      <Grid.Col span={6}>
        <GeneralForm />
      </Grid.Col>
      <Grid.Col span={6}>
        <PaperWithBorder title={t('group_change_password_title')}>
          <Stack mt={'md'}>
            <PortalButton
              variant={'outline'}
              Icon={BsFillLockFill}
              label={t('group_change_password_title')}
              onClick={() =>
                openDrawer({ content: <PasswordForm />, size: 'md', title: t('group_change_password_title') })
              }
            />
          </Stack>
        </PaperWithBorder>
        <Space h={'lg'} />
        <MfaCard
          title={t('group_two_step_title')}
          body={t('group_two_step_description')}
          enableButtonText={t('group_two_step_enable')}
          disableButtonText={t('group_two_step_disable')}
          isMfaEnabled={userData?.mfaSetting.enabled}
        />
      </Grid.Col>
    </Grid>
  );
};
